"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _genericInput = _interopRequireDefault(require("./generic-input"));

var RetypePasswordInput = function (_Component) {
  (0, _inheritsLoose2["default"])(RetypePasswordInput, _Component);

  function RetypePasswordInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.doPasswordsMatch = function (value) {
      if (_this.correspondingPasswordElement) {
        var correspondingValue = _this.correspondingPasswordElement.value;

        if (value === correspondingValue) {
          return {
            valid: true,
            errorMessage: ""
          };
        }

        return {
          valid: false,
          errorMessage: "Passwords do not match"
        };
      }

      console.warn("RetypePasswordInput could not validate. Unable to find corresponding password field with ID " + _this.props.correspondingPasswordId);
      return {
        valid: false,
        errorMessage: "Unable to find corresponding password field"
      };
    };

    _this.correspondingPasswordElement = null;
    return _this;
  }

  var _proto = RetypePasswordInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.correspondingPasswordElement = document.getElementById(this.props.correspondingPasswordId);

    if (!this.correspondingPasswordElement) {
      console.warn("RetypePasswordInput was unable to find corresponding password input to listen on");
    }
  };

  _proto.render = function render() {
    return _react["default"].createElement(_genericInput["default"], (0, _extends2["default"])({}, this.props, {
      inputType: "password",
      validator: this.doPasswordsMatch
    }));
  };

  return RetypePasswordInput;
}(_react.Component);

RetypePasswordInput.defaultProps = {
  labelText: "Retype password",
  inputId: "retype_password",
  inputName: "retype_password"
};
var _default = RetypePasswordInput;
exports["default"] = _default;